export const ConstraintsOperators: string[] = [
    "=",
    "!=",
    ">=",
    "<=",
    ">",
    "<"
];
